import axios from 'axios';

// Chamada relativa (mesma origem): agenda.sysfar.com.br/reservas -> o Apache
// roteia /reservas para o backend. Pode sobrescrever no build com REACT_APP_API_URL.
const baseURL = process.env.REACT_APP_API_URL || "";

const api = axios.create({ baseURL });

export const getReservas = async () => api.get('/reservas');
export const createReserva = async (reserva) => api.post('/reservas', reserva);
export const deleteReserva = async (id) => api.delete(`/reservas/${id}`);
